import { LatLng } from 'leaflet';

import { Ride } from '../../types/ride';
import { Marker } from '../../types/marker';

export interface PinData {
  position: LatLng;
  address: string;
  isDriverCoords?: boolean;
}

export type Pin = PinData | null;

export function isPinData(arg: any): arg is PinData {
  return arg && arg.position !== undefined;
}

export type SelectedObject = Ride | Marker | PinData | null;

export interface Place {
  coords: number[];
  name: string;
}

export interface MapProps {
  rides?: Ride[];
  hideHint?: boolean;
  onAddMarker?(lat: number | string, lng: number | string): void;
  isEditMode?: boolean;
  onDropRide?(id: number): void;
}
